import React, { useEffect, useState } from 'react';
import Toggle from 'material-ui/Toggle'
import { grey500 } from 'material-ui/styles/colors'

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Col, Row } from 'react-bootstrap';
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import Snackbar from 'material-ui/Snackbar';
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from 'material-ui/Table';

import { cloneDeep } from 'lodash';
import MaskedInput from 'react-text-mask';
import validator from 'validator'

import {
    createUser,
    deleteUser,
    toggleUserAccess,
    getUserById,
    getUsersByCompanyId,
    updateUser
} from '../../reducers/user/resources';
import { getProducts } from '../../reducers/products/resources';
import session from '../../utils/session';
import format from '../../utils/format';
import config from '../../config';

const MODE_ADD = 'add';
const MODE_EDIT = 'edit';

const UserList = () => {
    const [formData, setFormData] = useState({
        id: '',
        name: { value: '', error: '' },
        email: { value: '', error: '' },
        mobile: { value: '', error: ''},
        mode: MODE_ADD
    });
    const [usersList, setsUsersList] = useState([]);
    const [showSnackBar, setShowSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [miscData, setMiscData] = useState({
        department_id: '',
        text_optin: '',
        tfa_option: '',
        desktop_notification: '',
        email_notification: '',
        sms_notification: '',
        nickname: '',
        active: '',
        job_title: '',
        role: config.userRoles.user,
        timezone: '',
        productId: ''
    })

    const userData = session.get('userData')

    const styles = {
        style1: {
            margin: 12,
            padding: 10
        },
        style2: {
            marginLeft: 20
        },
        style3: {
            alignment: 'center'
        },
        style4: {
            margin: 7
        }
    };

    const resetFields = () => {
        let clonedData = cloneDeep(formData);
        const variables = ['name', 'email', 'mobile']

        variables.forEach(vars => {
            clonedData[vars].value = '';
            clonedData[vars].error = '';
        });

        clonedData.id = '';
        clonedData.mode = MODE_ADD;

        setMiscData({
            department_id: '',
            text_optin: '',
            tfa_option: '',
            desktop_notification: '',
            email_notification: '',
            sms_notification: '',
            nickname: '',
            active: '',
            job_title: '',
            role: config.userRoles.user,
            timezone: '',
            productId: ''
        })

        setFormData({ ...formData, ...clonedData })
    }

    const handleChange = (key, value) => {
        const cloneData = cloneDeep(formData);

        if(key === 'mobile') {
            const mainNumber = format.mobileCleanup(value);
            cloneData[key].value = mainNumber.length > 10 ? mainNumber.substring(1) : mainNumber;
        } else {
            cloneData[key].value = value;
        }
        
        if(cloneData[key].error) cloneData[key].error = '';

        setFormData({ ...formData, ...cloneData });
    }

    const handleDialogClose = (bool, mode) => {
        if(mode === MODE_ADD) {
            resetFields();
        }
        setIsOpenModal(bool)
    }

    const confirmDelete = userId => {
        setDeleteId(userId);
        setShowDeleteModal(true);
    }

    const handleEditUser = userId => {
        getUserById(userId).then(res => {
            const user = res.data;
            let clonedFormData = cloneDeep(formData);
            let clonedMiscData = cloneDeep(miscData);

            const obj = {
                true: 'yes',
                false: 'no'
            };

            const {
                department_id,
                tfa_option,
                desktop_notification,
                email_notification,
                sms_notification,
                nickname,
                active,
                job_title,
                role,
                text_optin,
                timezone,
                product_id
            } = user;

            clonedMiscData = {
                department_id,
                tfa_option: obj[tfa_option] || 'no', 
                desktop_notification: obj[desktop_notification],
                email_notification: obj[email_notification],
                sms_notification: obj[sms_notification],
                nickname,
                active: obj[active],
                job_title,
                role: role || config.userRoles.user,
                text_optin,
                timezone,
                productId: product_id
            }

            // remove + sign
			const mobile = user.mobile ? user.mobile.replace(/\s|\+|/g, '') : '';
            
            clonedFormData.id = user.id;
            clonedFormData.mode = MODE_EDIT;
            clonedFormData['name'].value = user.name;
            clonedFormData['email'].value = user.email;
            clonedFormData['mobile'].value = mobile.length > 10 ? mobile.substring(1) : mobile // check mobile number

            setFormData({ ...formData, ...clonedFormData });
            setMiscData({ ...miscData, ...clonedMiscData });
            handleDialogClose(true, MODE_EDIT)
        })
    }

    const handleMask = () => {
        return ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/];
    }

    const toggleSaveFields = (userId) => {
        console.log("toggle",userId)
        toggleUserAccess(userId)
        .then(() => {
            queryUsersPerCompany();
            setShowSnackBar(true);
            setSnackBarMessage('User access updated.');
        })
        .catch(() => {
            setShowSnackBar(true);
            setSnackBarMessage('Something went wrong.');
        })
    }

    const constructUserList = (users) => {
        const formattedData = users.map(user => {
            return (
              <TableRow key={user.id}>
                <TableRowColumn>{user.name}</TableRowColumn>
                <TableRowColumn>{user.email}</TableRowColumn>
                <TableRowColumn style={{ textAlign: "center" }}>
                  <Row>
                    <Col xs={6}>
                      <RaisedButton
                        label="Edit"
                        primary={true}
                        onClick={() => handleEditUser(user.id)}
                        style={styles.style4}
                      />
                    </Col>
                    <Col xs={6}>
                      <Toggle
                        tooltip="Toggle access to GoHire."
                        label={user.enabled?'Enabled':'Disabled'}
                        toggled={user.enabled}
                        onClick={() => toggleSaveFields(user.id)}
                        labelStyle={{
                          color: grey500,
                          fontWeight: "300",
                        }}
                        style={{ marginTop: "5px" }}
                      />
                    </Col>
                  </Row>

                  {/* <RaisedButton
							label="Disable"
							secondary={true}
							onClick={() => confirmDelete(user.id)}
							style={styles.style4}
						/> */}
                </TableRowColumn>
              </TableRow>
            );
        }) 

        setsUsersList(formattedData)
    }

    const queryUsersPerCompany = () => {
        getUsersByCompanyId(userData.companyId)
        .then(res => {
            const filtered = res.data.filter(data => {
                return !data.deleted_at && data.id !== userData.id
            })
            constructUserList(filtered)
        })
        .catch(() => {
            setShowSnackBar(true);
            setSnackBarMessage('Something is wrong.');
        })
    }

    const closeDeleteModal = () => {
        setDeleteId(null);
        setShowDeleteModal(false);
    }

    const handleDeleteUser = () => {
        deleteUser(deleteId)
        .then(() => {
            queryUsersPerCompany();

            setShowSnackBar(true);
            setSnackBarMessage('User has been successfully deleted.');
        })
        .catch(() => {
            setShowSnackBar(true);
            setSnackBarMessage('Something is wrong.');
        })
        .finally(() => {
            closeDeleteModal();
        });
    }

    const validateFields = () => {
        const clonedData = cloneDeep(formData)

        const requiredFields = [
            'name',
            'email'
        ]
        let hasError = false;

        requiredFields.forEach(field => {
             if(field === 'email' && !validator.isEmail(clonedData[field].value)) {
              clonedData[field].error = 'Invalid email address.';
                setSnackBarMessage('Invalid email address.');
                hasError = true;
            };

            if(clonedData[field].value === '') {
                clonedData[field].error = 'This field is required';
                setSnackBarMessage('Some fields are required.');
                hasError = true;
            };
        });

        setFormData({ ...formData, ...clonedData});

        return hasError;
    }

    const handleSubmit = async () => {
        
        // check if fields still has errors
        if(validateFields()) {
            setShowSnackBar(true)
            return
        };

        setShowSnackBar(false)
        setSnackBarMessage('');

        let textProduct;
        let clonedFormData = cloneDeep(formData);

        // Get 'Text' product
        const products = await getProducts();
        if(products.data) {
            textProduct = products.data.filter(product => product.name === 'Text')
        }
        
        let payload = {
            name: clonedFormData.name.value,
            username: clonedFormData.email.value,
            password: 'GoHire-gobe',
            department_id: userData.department_id,
            text_optin: 'yes',
            mobile: '',
            nickname: '',
            email: clonedFormData.email.value,
            active: 'yes',
            job_title: '',
            productId: textProduct.length ? textProduct[0].id : ''   
        }

        if(clonedFormData.mobile.value) {
			const prefix = '+1';
			payload.mobile = prefix.concat(clonedFormData.mobile.value);
		};

        if(clonedFormData.mode === MODE_EDIT) {
            const {
                department_id,
                tfa_option,
                desktop_notification,
                email_notification,
                sms_notification,
                nickname,
                active,
                job_title,
                role,
                text_optin,
                timezone,
                productId
            } = miscData;

            payload = {
                ...payload,
                department_id,
                tfa_option,
                desktop_notification,
                email_notification,
                sms_notification,
                nickname,
                active,
                job_title,
                role,
                text_optin,
                productId
            }

            if(timezone) {
                payload.timezone = timezone
            }

            updateUser(clonedFormData.id, payload)
                .then(() => {
                    queryUsersPerCompany();

                    setShowSnackBar(true);
                    setSnackBarMessage('User has been successfully updated.');

                    handleDialogClose(false)
                    resetFields();
                })
                .catch(err => {
                    let errorMessage = 'Something is wrong.';
                    if(err.error === 'duplicate_email') {
                        errorMessage = err.message;
                        clonedFormData['email'].error = errorMessage;
                    }

                    setFormData({ ...formData, ...clonedFormData });
                    setSnackBarMessage(errorMessage);
                    setShowSnackBar(true);
                })
        } else {
            payload.desktop_notif = 'yes';
            payload.email_notif = 'yes';
            payload.sms_notif = 'yes';

            createUser(payload)
                .then(() => {
                    queryUsersPerCompany();

                    setShowSnackBar(true);
                    setSnackBarMessage('User has been successfully added.');

                    handleDialogClose(!isOpenModal)
                    resetFields();
                })
                .catch(err => {
                    let errorMessage = 'Something is wrong.';
                    if(err.error === 'duplicate_email') {
                        errorMessage = err.message;
                        clonedFormData['email'].error = errorMessage;
                    }

                    setFormData({ ...formData, ...clonedFormData });
                    setSnackBarMessage(errorMessage);
                    setShowSnackBar(true);
                })
        }

        
    }

    useEffect(() => {
        queryUsersPerCompany();
    }, []);

    const actionButtons = [
        <RaisedButton
            label="Close"
            primary={true}
            keyboardFocused={true}
            onClick={() => handleDialogClose(false)}
            style={styles.style4}
        />,
        <RaisedButton
            label="Submit"
            primary={true}
            keyboardFocused={true}
            onClick={handleSubmit}
            style={styles.style4}
        />
    ]

    const deleteActionButtons = [
        <RaisedButton
            label="No"
            primary={true}
            keyboardFocused={true}
            onClick={closeDeleteModal}
            style={styles.style4}
        />,
        <RaisedButton
            label="Yes"
            primary={true}
            keyboardFocused={true}
            onClick={handleDeleteUser}
            style={styles.style4}
        />
    ]

    return (
        <Paper
            style={{ padding: '10px', margin: '10px', boxShadow: 'none' }}
        >
            <Snackbar
                open={showSnackBar}
                message={snackBarMessage}
                autoHideDuration={4000}
                onRequestClose={() => setShowSnackBar(false)}
            />
            <Row>
                <Col xs={12}>
                    <RaisedButton
                        label="Add New User"
                        primary={true}
                        onClick={() => handleDialogClose(true, MODE_ADD)}
                        style={styles}
                    />
                </Col>
            </Row>
            <Row>
                <Table fixedHeader={true} height='calc(100vh - 345px)'>
                    <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        enableSelectAll={false}
                    >
                        <TableRow>
                            <TableHeaderColumn>Name</TableHeaderColumn>
                            <TableHeaderColumn>Email/Username</TableHeaderColumn>
                            <TableHeaderColumn style={{ textAlign: 'center' }}>
                                Action
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>{usersList}</TableBody>
                </Table>
            </Row>
            <Dialog
                title={formData.mode === MODE_EDIT ? "Update User" : "Add New User"}
                actions={actionButtons}
                modal={false}
                open={isOpenModal}
                onRequestClose={() => handleDialogClose(false)}
                autoScrollBodyContent={true}
            >
                <div style={styles.style1}>
                    <TextField
                        fullWidth={true}
                        value={formData.name.value}
                        onChange={(e) => handleChange('name', e.target.value)}
                        floatingLabelText="Full Name"
                        errorText={formData.name.error}
                    />
                    <TextField
                        fullWidth={true}
                        value={formData.email.value}
                        onChange={(e) => handleChange('email', e.target.value)}
                        floatingLabelText="Email"
                        errorText={formData.email.error}
                    />
                    <TextField
                        fullWidth={true}
                        value={formData.mobile.value}
                        onChange={(e) => handleChange('mobile', e.target.value)}
                        floatingLabelText="Mobile"
                    >
                        <MaskedInput
                            value={formData.mobile.value}
                            mask={handleMask}
                        />
                    </TextField>
                </div>
            </Dialog>
            <Dialog
                actions={deleteActionButtons}
                modal={false}
                open={showDeleteModal}
                onRequestClose={closeDeleteModal}
            >
                Are you sure you wanna delete this user?
            </Dialog>
        </Paper>
    )
}

export default UserList;